import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "numberOfColumns", "xs", "sm", "md", "lg", "gutterValue", "gutterSize", "xsGutterValue", "smGutterValue", "mdGutterValue", "lgGutterValue", "xsOffset", "smOffset", "mdOffset", "lgOffset", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import { GridColumn } from './Column.styles';

var Column = function Column(_ref) {
  var className = _ref.className,
      numberOfColumns = _ref.numberOfColumns,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      gutterValue = _ref.gutterValue,
      gutterSize = _ref.gutterSize,
      xsGutterValue = _ref.xsGutterValue,
      smGutterValue = _ref.smGutterValue,
      mdGutterValue = _ref.mdGutterValue,
      lgGutterValue = _ref.lgGutterValue,
      xsOffset = _ref.xsOffset,
      smOffset = _ref.smOffset,
      mdOffset = _ref.mdOffset,
      lgOffset = _ref.lgOffset,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var columnBreakpoints = [{
    breakpoint: 'xs',
    columns: xs,
    offset: xsOffset,
    gutterValue: xsGutterValue
  }, {
    breakpoint: 'sm',
    columns: sm,
    offset: smOffset,
    gutterValue: smGutterValue
  }, {
    breakpoint: 'md',
    columns: md,
    offset: mdOffset,
    gutterValue: mdGutterValue
  }, {
    breakpoint: 'lg',
    columns: lg,
    offset: lgOffset,
    gutterValue: lgGutterValue
  }];
  return /*#__PURE__*/React.createElement(GridColumn, _extends({
    className: className,
    numberOfColumns: numberOfColumns,
    columnBreakpoints: columnBreakpoints,
    gutterValue: gutterValue,
    gutterSize: gutterSize
  }, props), children);
};

Column.propTypes = {
  /**
   * Prop for the column width at xs breakpoint
   */
  xs: PropTypes.number,

  /**
   * Prop for the column width at sm breakpoint
   */
  sm: PropTypes.number,

  /**
   * Prop for the column width at md breakpoint
   */
  md: PropTypes.number,

  /**
   * Prop for the column width at lg breakpoint
   */
  lg: PropTypes.number,

  /**
   * Prop for the number of columns the entire parent Row width is split into
   */
  numberOfColumns: PropTypes.number,

  /**
   * Specify the base gutter styling to use for this column. -1 for negative margins,
   * 0 for no margins and 1 for a left-margin. Inherited from parent Row container if unspecified.
   */
  gutterValue: PropTypes.oneOf([-1, 0, 1]),

  /**
   * Prop for width of gutters
   */
  gutterSize: PropTypes.string,

  /**
   * Optional prop for overriding the base gutterValue at xs breakpoint
   */
  xsGutterValue: PropTypes.oneOf([-1, 0, 1]),

  /**
   * Optional prop for overriding the base gutterValue at sm breakpoint
   */
  smGutterValue: PropTypes.oneOf([-1, 0, 1]),

  /**
   * Optional prop for overriding the base gutterValue at md breakpoint
   */
  mdGutterValue: PropTypes.oneOf([-1, 0, 1]),

  /**
   * Optional prop for overriding the base gutterValue at lg breakpoint
   */
  lgGutterValue: PropTypes.oneOf([-1, 0, 1]),

  /**
   * Optional prop to offset the component by a specified number of columns at xs breakpoint
   */
  xsOffset: PropTypes.number,

  /**
   * Optional prop to offset the component by a specified number of columns at sm breakpoint
   */
  smOffset: PropTypes.number,

  /**
   * Optional prop to offset the component by a specified number of columns at md breakpoint
   */
  mdOffset: PropTypes.number,

  /**
   * Optional prop to offset the component by a specified number of columns at lg breakpoint
   */
  lgOffset: PropTypes.number
};
Column.displayName = 'Column';
Column.defaultProps = {
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xsOffset: null,
  smOffset: null,
  mdOffset: null,
  lgOffset: null,
  xsGutterValue: null,
  smGutterValue: null,
  mdGutterValue: null,
  lgGutterValue: null
};
export default Column;